import { useCallback } from 'react';
import { useInfiniteResource } from 'hooks/useInfiniteResource';
import salesforceEntitiesService from 'services/salesforceEntitiesService';

// filters: { search, entityType, status } — changing any of them rebuilds fetchFn,
// which resets the infinite list back to page 1.
const useEntities = (perPage = 25, filters = {}) => {
	const { search = '', entityType = '', status = '' } = filters;

	const fetchFn = useCallback(
		async (pageNumber) => {
			const response = await salesforceEntitiesService.getEntities(
				pageNumber,
				perPage,
				{ search, entityType, status }
			);
			return {
				data: response?.entities || [],
				totalCount: response?.total || 0,
			};
		},
		[perPage, search, entityType, status]
	);

	const {
		data,
		totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
		refresh,
	} = useInfiniteResource({ fetchFn });

	return {
		entities: data,
		total: totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
		refresh,
		perPage,
	};
};

export default useEntities;
